import jQuery from "jquery";

jQuery(".carousel-gallery .carousel-inner").each(function (e) {
  var _height = Math.floor(jQuery(this).width() / 1.5);
  jQuery(this).find(".carousel-image").height(_height);
});

setTimeout(function () {
  jQuery(".carousel-gallery .carousel-inner").each(function (e) {
    var _height = Math.floor(jQuery(this).width() / 1.5);
    jQuery(this).find(".carousel-image").height(_height);
  });
}, 100);

jQuery(window).on("resize", function () {
  jQuery(".carousel-gallery .carousel-inner").each(function (e) {
    var _height = Math.floor(jQuery(this).width() / 1.5);
    jQuery(this).find(".carousel-image").height(_height);
  });
});

jQuery(".thumbnail-indicator li a").on("click", function (e) {
  e.preventDefault();
  jQuery(this).parent().parent().find("li").removeClass("active");
  jQuery(this).parent().addClass("active");
  jQuery(jQuery(this).data("bs-target")).carousel(jQuery(this).data("bs-id"));
});

jQuery(".carousel-gallery").on("slid.bs.carousel", function () {
  const sliderId = jQuery(this).attr("id");
  const index = jQuery(this).find("div.active").index();
  jQuery(`#${sliderId}_indicator li`).each(function (e) {
    jQuery(this).removeClass("active");
    if (jQuery(this).children("a").data("bs-id") === index) {
      jQuery(this).addClass("active");
      if (jQuery(this).children("a").data("bs-id") === 0) {
        jQuery(`#${sliderId}_indicator`).animate(
          {
            scrollLeft: 0,
          },
          1000,
        );
      }

      if (
        jQuery(this).offset().left > jQuery(`#${sliderId}_indicator`).width()
      ) {
        jQuery(`#${sliderId}_indicator`).animate(
          {
            scrollLeft: `+=${jQuery(this).width() + 10}`,
          },
          500,
        );
      }
    }
  });
});

jQuery(".carousel-indicator-controls.indicator-controls-prev").on(
  "click",
  function (e) {
    var _indicator = jQuery(this).data("indicator");
    var _scroll = Math.floor(jQuery(_indicator).width() * 0.7);
    jQuery(_indicator).animate(
      {
        scrollLeft: `-=${_scroll}px`,
      },
      500,
    );
  },
);

jQuery(".carousel-indicator-controls.indicator-controls-next").on(
  "click",
  function (e) {
    var _indicator = jQuery(this).data("indicator");
    var _scroll = Math.floor(jQuery(_indicator).width() * 0.7);
    jQuery(_indicator).animate(
      {
        scrollLeft: `+=${_scroll}px`,
      },
      500,
    );
  },
);

jQuery(".module .carousel-gallery .carousel-inner").on("click", function (e) {
  if (jQuery(window).outerWidth() >= 992) {
    var $wrapper = jQuery(this).parent().parent();
    var $row = jQuery($wrapper).parent();

    if ($wrapper.hasClass("absolute-carousel")) {
      jQuery($row).removeAttr("style");
      $wrapper.removeClass("absolute-carousel");
    } else {
      jQuery($row).height($row.height());
      $wrapper.addClass("absolute-carousel");
    }

    jQuery(".carousel-gallery .carousel-inner").each(function (e) {
      var _height = Math.floor(jQuery(this).width() / 1.5);
      jQuery(this).find(".carousel-image").height(_height);
    });
  }
});
